import AuthPage from "components/shared/AuthPage";
import SideBlock from "components/shared/SideBlock";
import CreateYourAccount from "components/SignUp";

const SignUp = () => {
    return (
        <AuthPage userAuthenticated={true}>
            <SideBlock />
            <CreateYourAccount />
        </AuthPage>
    );
};

export default SignUp;
